import { render, staticRenderFns } from "./Progress_magister.vue?vue&type=template&id=64dd9f1e"
import script from "./Progress_magister.vue?vue&type=script&lang=js"
export * from "./Progress_magister.vue?vue&type=script&lang=js"
import style0 from "./Progress_magister.vue?vue&type=style&index=0&id=64dd9f1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports